import { InputFilter } from '@lifebit-ai/lds'
import React from 'react'

interface DataAccessRequestDatasetFilterProps {
  onApply: (searchTerm: string) => void
  onReset: () => void
}

export const DataAccessRequestDatasetFilter = ({ onApply, onReset }: DataAccessRequestDatasetFilterProps) => {
  return (
    <InputFilter label="Dataset" searchFieldPlaceholder="Search dataset name" onApply={onApply} onReset={onReset} />
  )
}
